import { parseAbi } from 'viem'

export const lockV3Abi = parseAbi([
  'function getTotalLockCount() view returns (uint256)',
  'function getLockAt(uint256 index) view returns ((uint256 lockId, uint256 nftId, address nonFungiblePositionManagerAddress, address owner, uint256 lockDate, uint256 unlockDate, bool isUnlocked, string description))',
  'function nonFungiblePositionManagerName(address) view returns (string)',
  'function priceInNative() view returns (uint256)',
  'function priceInCbon() view returns (uint256)',
  'function cbonAddress() view returns (address)',
  'function owner() view returns (address)',
] as const)

export const lockV2Abi = parseAbi([
  'function getTotalLockCount() view returns (uint256)',
  'function getLockAt(uint256 index) view returns ((uint256 id, address token, address owner, uint256 amount, uint256 lockDate, uint256 tgeDate, uint256 tgeBps, uint256 cycle, uint256 cycleBps, uint256 unlockedAmount, string description))',
  'function cumulativeLockInfo(address) view returns (address token, address factory, uint256 amount)',
  'function withdrawableTokens(uint256 lockId) view returns (uint256)',
  'function priceInNative() view returns (uint256)',
  'function priceInCbon() view returns (uint256)',
  'function cbonAddress() view returns (address)',
  'function receiver() view returns (address)',
] as const)

export const lockV3ListAbi = parseAbi([
  'function allSupportedNonFungiblePositionManagerCount() view returns (uint256)',
  'function getNonFungiblesPositionManager(uint256 start, uint256 end) view returns (uint256, address[], string[])',
] as const)

export const erc20Abi = parseAbi([
  'function name() view returns (string)',
  'function symbol() view returns (string)',
  'function decimals() view returns (uint8)',
  'function totalSupply() view returns (uint256)',
  'function balanceOf(address) view returns (uint256)',
] as const)

export const pairAbi = parseAbi([
  'function factory() view returns (address)',
  'function token0() view returns (address)',
  'function token1() view returns (address)',
  'function getReserves() view returns (uint112 r0, uint112 r1, uint32 t)',
  'function totalSupply() view returns (uint256)',
] as const)

/** The words after the tick are read as uint256: Uniswap and PancakeSwap type feeProtocol differently, every word is 32 bytes either way. */
export const poolAbi = parseAbi([
  'function slot0() view returns (uint160 sqrtPriceX96, int24 tick, uint256 a, uint256 b, uint256 c, uint256 d, uint256 e)',
  'function liquidity() view returns (uint128)',
] as const)

export const managerAbi = parseAbi([
  'function balanceOf(address owner) view returns (uint256)',
  'function tokenOfOwnerByIndex(address owner, uint256 index) view returns (uint256)',
  'function getApproved(uint256 tokenId) view returns (address)',
  'function positions(uint256 tokenId) view returns (uint96 nonce, address operator, address token0, address token1, uint24 fee, int24 tickLower, int24 tickUpper, uint128 liquidity, uint256 feeGrowthInside0LastX128, uint256 feeGrowthInside1LastX128, uint128 tokensOwed0, uint128 tokensOwed1)',
  'function factory() view returns (address)',
  'function ownerOf(uint256 tokenId) view returns (address)',
] as const)

export const v3FactoryAbi = parseAbi(['function getPool(address, address, uint24) view returns (address)'] as const)
export const v2FactoryAbi = parseAbi(['function getPair(address, address) view returns (address)', 'function allPairsLength() view returns (uint256)', 'function allPairs(uint256) view returns (address)'] as const)
export const lockEventsAbi = parseAbi([
  'event LockAdded(uint256 indexed lockId, uint256 nftId, address nonFungiblePositionManagerAddress, address owner, uint256 unlockDate)',
] as const)
export const lockV2EventsAbi = parseAbi(['event LockAdded(uint256 indexed id, address token, address owner, uint256 amount, uint256 unlockDate)'] as const)

/** The write functions of the lockers, exactly as in their verified sources (CADINU-Audit/source/contracts/verified). */
export const lockV3WriteAbi = parseAbi([
  'function lockByNative(address _owner, uint256 _nftId, address _nonFungiblePositionManagerAddress, uint256 _unlockDate, string _description) payable returns (uint256 id)',
  'function lockByCbon(address _owner, uint256 _nftId, address _nonFungiblePositionManagerAddress, uint256 _unlockDate, string _description) returns (uint256 id)',
  'function unlock(uint256 _lockId)',
  'function collectFee(uint256 _lockId, address _recipient, uint128 _amount0Max, uint128 _amount1Max)',
  'function expandLockTime(uint256 _lockId, uint256 _newUnlockDate)',
  'function editLockDescription(uint256 _lockId, string _description)',
  'function transferLockOwnership(uint256 _lockId, address _newOwner)',
  'function renounceLockOwnership(uint256 _lockId)',
] as const)

export const lockV2WriteAbi = parseAbi([
  'function lockByNative(address owner, address token, bool isLpToken, uint256 amount, uint256 unlockDate, string description) payable returns (uint256 id)',
  'function lockByCbon(address owner, address token, bool isLpToken, uint256 amount, uint256 unlockDate, string description) returns (uint256 id)',
  'function vestingLockByNative(address owner, address token, bool isLpToken, uint256 amount, uint256 tgeDate, uint256 tgeBps, uint256 cycle, uint256 cycleBps, string description) payable returns (uint256 id)',
  'function vestingLockByCbon(address owner, address token, bool isLpToken, uint256 amount, uint256 tgeDate, uint256 tgeBps, uint256 cycle, uint256 cycleBps, string description) returns (uint256 id)',
  'function unlock(uint256 lockId)',
  'function editLock(uint256 lockId, uint256 newAmount, uint256 newUnlockDate)',
  'function editLockDescription(uint256 lockId, string description)',
  'function transferLockOwnership(uint256 lockId, address newOwner)',
  'function renounceLockOwnership(uint256 lockId)',
] as const)

export const approveAbi = parseAbi([
  'function approve(address spender, uint256 amountOrTokenId)',
  'function allowance(address owner, address spender) view returns (uint256)',
  'function getApproved(uint256 tokenId) view returns (address)',
  'function isApprovedForAll(address owner, address operator) view returns (bool)',
] as const)

export const collectAbi = parseAbi(['function collect((uint256 tokenId, address recipient, uint128 amount0Max, uint128 amount1Max) params) returns (uint256 amount0, uint256 amount1)'] as const)
